export default __webpack_public_path__ + "static/img_2-fe952835bd2f557fc574b869c4a312b6.png";